/**
 * The service an object row shows in the objects overview: the name of its
 * product's category (#3167, the product IS the service), the same name the
 * room form shows read-only when the object is created.
 *
 * The overview's `productId` is the object's Group (cell), not the product, so
 * the walk is cell → product (`AdminGroup.productId`, the `group.product_id`
 * pointer) → category. Any missing link — no product, no category, a list that
 * did not load — leaves the cell out of the map, and the row falls back to the
 * use-case label as before.
 */
export const serviceNamesByCellId = (
    cells: { id: string, productId: string | null }[],
    products: { id: string, productCategoryId: string | null }[],
    categories: { id: string, name: string }[],
): Map<string, string> => {
    const categoryOfProduct = new Map(products.map((product) => [product.id, product.productCategoryId]));
    const categoryName = new Map(categories.map((category) => [category.id, category.name]));
    const names = new Map<string, string>();
    cells.forEach((cell) => {
        const categoryId = cell.productId ? categoryOfProduct.get(cell.productId) : null;
        const name = categoryId ? categoryName.get(categoryId) : undefined;
        if (name) names.set(cell.id, name);
    });
    return names;
};
